const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.teck.forwoodsafety.com',
    USER_TOKEN_URL: 'https://chf3yer9c1.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://1h2kd7n4ob.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.staging.teck.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.staging.teck.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.staging.teck.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.teck.forwoodsafety.com',
    WEBSOCKET: 'wss://hop65qwi7i.execute-api.us-west-2.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
